import React, { useEffect, useState } from 'react';
import { Empty, Spin, ConfigProvider } from 'antd';
import useMetaStore, { useMeta } from '@/store/useMetaStore';
import useValuesStore, { useValues } from '@/store/useValuesStore';
import StoreContext from '@/store/context';
import zhCN from 'antd/es/locale/zh_CN';
import SPTableWithModel from '@/components/SPTableWithModel';

const AssetModuleTable = React.forwardRef((props: any, ref) => {
  return <SPTableWithModel {...props} ref={ref} />;
});

export default React.forwardRef((props: any, ref) => {
  const values = useValues();
  const meta = useMeta();
  return (
    <StoreContext.Provider value={{ values, meta }}>
      <ConfigProvider locale={zhCN}>
        <AssetModuleTable {...props} ref={ref} />
      </ConfigProvider>
    </StoreContext.Provider>
  );
});
